module.exports = __webpack_public_path__ + "static/Gargoyle-e0e9ba2b0cad8fdd0c09374b93d71860.jpg";